import { render } from "./LoadingSpinner.vue?vue&type=template&id=5ef6a7d7&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=5ef6a7d7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ef6a7d7"

export default script